import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { InnerBlocks, useBlockProps } from "@wordpress/block-editor";
import parse from "html-react-parser";

export default function WrapperSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div
      {...useBlockProps.save({
        className: "grid-container",
      })}
    >
      <InnerBlocks.Content />
    </div>
  );
}
